var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"GoToNextScenarioPage",attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.goTo()}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }